import React from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, Box, Typography, Button } from "@mui/material";
import { CheckCircle2, Sparkles } from "lucide-react";

const ACCENT = "#f77f00";
const ACCENT_SOFT = "#fff4e5";
const TEXT_PRIMARY = "#1f2733";
const TEXT_SECONDARY = "#5b6472";

export default function SucessMsgQb({ details }) {
  const navigate = useNavigate();

  return (
    <Dialog
      open={true}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          p: 1,
          overflow: "hidden",
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            p: 4,
            background: "linear-gradient(180deg, #fff 0%, #fffaf5 100%)",
          }}
        >
          {/* Success Icon */}
          <Box
            sx={{
              position: "relative",
              width: 80,
              height: 80,
              borderRadius: "50%",
              background: ACCENT_SOFT,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 3,
              boxShadow: "0 4px 20px rgba(247,127,0,0.15)",
            }}
          >
            <CheckCircle2 size={44} color={ACCENT} strokeWidth={2.2} />
            <Box
              sx={{
                position: "absolute",
                top: 2,
                right: 2,
                background: "#fff",
                borderRadius: "50%",
                p: 0.5,
                display: "flex",
                boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
              }}
            >
              <Sparkles size={14} color="#f59e0b" />
            </Box>
          </Box>

          {/* Title */}
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: 800,
              color: TEXT_PRIMARY,
              mb: 1,
              letterSpacing: "-0.3px",
            }}
          >
            Saved Successfully!
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontSize: "13.5px",
              color: TEXT_SECONDARY,
              lineHeight: 1.6,
              mb: 3.5,
              maxWidth: "280px",
            }}
          >
            You have successfully saved{" "}
            <b style={{ color: TEXT_PRIMARY }}>
              "{details?.name || "Question Bank"}"
            </b>{" "}
            to your library.
          </Typography>

          {/* Okay Button */}
          <Button
            variant="contained"
            fullWidth
            onClick={() => navigate("/questionLibrary")}
            sx={{
              background: ACCENT,
              color: "#fff",
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 700,
              fontSize: "14px",
              py: 1.2,
              boxShadow: "0 4px 12px rgba(247,127,0,0.25)",
              "&:hover": {
                background: "#e56f00",
                boxShadow: "0 6px 16px rgba(247,127,0,0.35)",
              },
            }}
          >
            Okay, Got it
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
